/**
 * Created by Languagenut on 10/10/2019.
 */

import React  from 'react';
import ReportServices from '../../../services/reports-service.js';
import {Breadcrumb , Table , ProgressBar , Form , Button , Card , Row  , Col , Pagination} from 'react-bootstrap'
import Translation from '../../../store/internationalization-store.js';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import Downloader from '../../../classes/download.js';


let ranges = [
    {thresholdLower:70 , thresholdHigher:100 , total:0 , color:"#88c057"},
    {thresholdLower:40 , thresholdHigher:70  , total:0 , color:"#ffcc66"},
    {thresholdLower:1 , thresholdHigher:40   ,  total:0 , color:"#ed7161"},
    {thresholdLower:0 , thresholdHigher:0   ,  total:0 , color:"#ffffff"}
];

export default class detail extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {

        }
    }


    getBackgroundColor(value){
        var test = function(value , thresholdLower , thresholdHigher){

            value = String(value).replace('%' , '');

            console.log(value)
            if(value == 0 && thresholdLower == 0)
            {
                return true;
            }

            return value > Number(thresholdLower) && value <= Number(thresholdHigher)
        };


        let col;


        for(var r = 0 ; r < ranges.length; r++)
        {
            if(test(value , ranges[r].thresholdLower , ranges[r].thresholdHigher))
            {
                col = ranges[r].color
                break;
            }
        }


        return col;
    }

    componentWillReceiveProps(props){
        this.props = props
        this.setState({update:true})
    }

    componentDidMount(){
        ReportServices.getLanguageCourseDetail(this.props.module.uid , this.props.classID , this.props.studentID , this.props.language , this.props.set , this.props.due ).then(function(response){
            this.setState({
                data:response.data
            })
        }.bind(this));
    }


    componentWillReceiveProps(props) {
        this.props = props

        if(this.props.triggerDownload)
        {
            this.handelDownloadRequest();
        }
    }

    handelDownloadRequest(){
        var csv = [];
        var row = ["" , Translation.getModuleNoIndexTranslation(this.props.module.title , this.props.module.title)];
        csv.push(row.join(","));

        var row = ["" , Translation.get('119' , 'Reading') , Translation.get('117' , 'Listening') , Translation.get('118', 'Speaking') , Translation.get('120', 'Writing'), Translation.get('12223', 'Average')];
        csv.push(row.join(","));


        for(var idx = 0 ; idx < this.state.data.length; idx++)
        {
            var _row = this.state.data[idx];
            var row = [];
            row.push(_row.name);

            row.push(_row['10']);
            row.push(_row['4']);
            row.push(_row['1']);
            row.push(_row['7']);
            row.push(_row['avg']);
            csv.push(row.join(","));
        }


        (new Downloader()).download_csv(csv.join("\n"));
    }

    getTableData(){
        return this.state.data || [{},{},{}]
    }

    formatterColor(cell){

        console.log(arguments)
        return {
            background:this.getBackgroundColor(cell)
        }
    }

    render(){

        const tableOptions = {
            page: 1,  // which page you want to show as default
            sizePerPage: 30,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationShowsTotal: false,
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            hideSizePerPage: true,
            alwaysShowAllBtns: true, // Always show next and previous button
            withFirstAndLast:true,
            firstPage: '...', // First page button text
            lastPage: '...', // Last page button text
        };



        return <BootstrapTable options={tableOptions} data={ this.getTableData() } keyField='id'   pagination  bordered={ true }>
            <TableHeaderColumn row='0' rowSpan='2' width={'20%'} dataField='name' ></TableHeaderColumn>
            <TableHeaderColumn row='0' colSpan='5' dataField='title' >
                <a onClick={this.props.onClick} ><i className="zmdi zmdi-arrow-left"></i>&nbsp;&nbsp;{Translation.getModuleNoIndexTranslation(this.props.module.title , this.props.module.title)}</a>
            </TableHeaderColumn>
            <TableHeaderColumn tdStyle={ this.formatterColor.bind(this) } row='1' rowSpan='1' dataField={10} ><small>{Translation.get(119 , 'Reading')}</small></TableHeaderColumn>
            <TableHeaderColumn tdStyle={ this.formatterColor.bind(this) } row='1' rowSpan='1' dataField={4} ><small> {Translation.get(117 , 'Reading')}</small></TableHeaderColumn>
            <TableHeaderColumn tdStyle={ this.formatterColor.bind(this) } row='1' rowSpan='1' dataField={1} ><small>{Translation.get(118 , 'Reading')}</small></TableHeaderColumn>
            <TableHeaderColumn tdStyle={ this.formatterColor.bind(this) } row='1' rowSpan='1' dataField={7} ><small>{Translation.get(120 , 'Reading')} </small></TableHeaderColumn>
            <TableHeaderColumn tdStyle={ this.formatterColor.bind(this) } row='1' rowSpan='1' dataField={"avg"} ><small>{Translation.get(12223 , 'Reading')}</small></TableHeaderColumn>
        </BootstrapTable>

    }

}